var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradevalue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1037",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1039",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452.3,153.5H421.1L325.9,58.3a25,25,0,0,0-35.3,35.4l59.8,59.8H161.6l59.8-59.8a25.108,25.108,0,0,0,0-35.4,25.169,25.169,0,0,0-35.4,0L90.8,153.5H59.7a50.018,50.018,0,0,0-50,50V208a50.034,50.034,0,0,0,43.1,49.5L76.6,418.3A50.376,50.376,0,0,0,126.1,461H385.8a50.286,50.286,0,0,0,49.5-42.7l23.8-160.8A50.11,50.11,0,0,0,502.2,208v-4.5A49.869,49.869,0,0,0,452.3,153.5Zm-147.6-74a5.017,5.017,0,0,1-1.5-3.5,4.726,4.726,0,0,1,1.5-3.5,5.134,5.134,0,0,1,7.1,0l81,81H378.7Zm-104.5-7a4.951,4.951,0,0,1,7.1,0,5.017,5.017,0,0,1,1.5,3.5,4.726,4.726,0,0,1-1.5,3.5l-74,74H119.2ZM415.5,415.4A30.19,30.19,0,0,1,385.8,441H126.2a30.19,30.19,0,0,1-29.7-25.6L73.2,258H438.9ZM482.3,208a30.088,30.088,0,0,1-30,30H59.7a30.088,30.088,0,0,1-30-30v-4.5a30.088,30.088,0,0,1,30-30H452.3a30.088,30.088,0,0,1,30,30V208Z",
    fill: "#470985",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.6,298.3a10,10,0,0,0,0-20H216.4a10,10,0,0,0,0,20h22.7a23.9,23.9,0,0,1,21.8,14H216.5a10,10,0,1,0,0,20h44.4a24.067,24.067,0,0,1-21.8,14H216.4a10.03,10.03,0,0,0-6.9,17.3l56.6,53.5a10.012,10.012,0,0,0,6.9,2.7,10.311,10.311,0,0,0,7.3-3.1,9.963,9.963,0,0,0-.4-14.1l-38.4-36.3a44.133,44.133,0,0,0,40.4-33.9h13.7a10,10,0,0,0,0-20H281.9a43.639,43.639,0,0,0-6-14h19.7v-.1Z",
    fill: "#470985",
    className: "color000 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradevalue);
export default __webpack_public_path__ + "static/media/tradevalue.913ba1e1b3d34a041bc145f97aadd72a.svg";
export { ForwardRef as ReactComponent };